<div class="padding flex column">
	<b class="bold margin-bottom">Approvation</b>

	@if(data == ShotApprovalStatus.Approved){
	<div class="bg-green white padding-small">
		Are you sure to
		<b>approve</b>
		selected shots?
	</div>
	} @else if(data == ShotApprovalStatus.Rejected) {
	<div class="bg-red white padding-small">
		Are you sure to
		<b>reject</b>
		selected shots?
	</div>
	} @else if (data == ShotApprovalStatus.ToReshoot){
	<div class="bg-orange padding-small">
		Are you sure to
		<b>reshoot</b>
		selected shots?
	</div>
	} @else {
	<div class="bg-orange padding-small">
		Are you sure to
		<b>undo</b>
		selected shots?
	</div>
	}

	<div class="flex-1 flex column margin-top">
		<b>Notes</b>
		<textarea class="fix-height full-width margin-top-smallest" matInput [(ngModel)]="note" style="resize: none; overflow: auto"></textarea>
	</div>

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>

			<button (click)="confirm()">
				<i class="fa-solid fa-check"></i>
				Confirm
			</button>
		</div>
	</div>
</div>
